import { Constants } from 'unison';

export const MOST_COMMON_LABELS_REQUEST_COUNT = 5000;
export const NUM_COLUMNS = 3;
export const GRID_WIDTH = parseInt(Constants.wideMeasure, 10) - 50;
export const GRID_HEIGHT = 360;
